
/* Use case: Index Headline page */
ADILF.define('adilf/pages/index/main',[
        'streamhub-sdk/jquery', 
        'adilf/context', 
        'adilf/apps/social/util/subnav-highlighter',
        'adilf/apps/social/promo-modules/social-media/app',
        'adilf/apps/social/util/google-analytics'
    ], function(jquery, Context, SubnavHighlighter, SocialMediaPromo, GoogleAnalytics) {
    "use strict";

    return {
        init: function() {

            var self = this;

            new SubnavHighlighter().highlight();

            var gaHandler = new GoogleAnalytics({
                name: 'Index',
                prefix: 'page',
                label: 'page:'+ (window.location.pathname.replace(/index\.html$/, '').replace(/^\/|\/$/g, '') || 'home')
            });

            new SocialMediaPromo({
                name: 'SocialMediaPromo',
                network: Context.getNetworkId(),
                siteId: Context.getSiteId(),
                environment: Context.getEnvironmentId(),
                gaHandler: gaHandler
            });

            if(jquery('.livefyre-commentcount').length > 0) {
                require(['adilf/apps/commentcount/app'], function(CommentCount) {
                    var cc = new CommentCount();
                });
            }

            var heatmap = function() {
                require(['adilf/apps/heatmap/app'], function(Heatmap) {
                    self.debug.print("Intializing Heatmap");
                    var heatmap = new Heatmap({
                        'name': 'RightRailHeatmap',
                        'el': 'most-comments',
                        'networkId': Context.getNetworkId(),
                        'siteId': Context.getSiteId()
                    });
                });
            };
            // Most cases -- load ASAP
            if(jquery('#most-comments').length > 0) {
                heatmap();
            } else {
                // SSF case -- wait for DOM
                jquery(document).ready(function() {
                    if(jquery('#most-comments').length > 0) {
                        heatmap();
                    }
                });
            }

            // Pagebuilder indexes with gallery module enabled
            if(jquery('#livefyre-wall-uw').length > 0) {
                require([
                    'rangle/upload-wall',
                    'adilf/auth/sdk-auth-delegate',
                    'adilf/handler',
                    'auth',
                    'streamhub-sdk/collection'
                ], function(UploadWall, AuthDelegate, Handler, auth, Collection) {
                    var wall = UploadWall.create({
                        id: 'livefyre-wall-uw',
                        autoload: true,
                        dependencies: {
                            auth: auth,
                            SDK: { Collection: Collection }
                        }
                    });
                    Handler.apps[wall.name] = wall;
                });
            }

            if(jquery('#livefyre-wall').length > 0) {
                require(['adilf/apps/wall/app'], function(Wall) {
                    var wall = new Wall({
                        'el': 'livefyre-wall',
                        'networkId': Context.getNetworkId(),
                        'siteId': Context.getSiteId()
                    });
                });
            }
        }
    };

});